import React, { useContext, useEffect, useState } from 'react';
import { AnalyticsService } from './AnalyticsService';
const AnalyticsContext = /*#__PURE__*/React.createContext(undefined);
const AnalyticsProvider = ({
  settings,
  children,
  history
}) => {
  const [isInitialized, setIsInitialized] = useState(false);
  useEffect(() => {
    setIsInitialized(true);
  }, []);
  return /*#__PURE__*/React.createElement(AnalyticsContext.Provider, {
    value: new AnalyticsService(settings, history, isInitialized)
  }, children);
};
function useAnalyticsContext() {
  const context = useContext(AnalyticsContext);
  if (context === undefined) {
    throw new Error('useAnalyticsContext must be used within a AuthProvider');
  }
  return context;
}
export { AnalyticsProvider, useAnalyticsContext };